import "../App.css";

export default function Loader() {
  return (
    <>
      <span className="loader"></span>&nbsp; Saving counter value
    </>
  );
}
